import React from 'react';

export const InputError = (props) => <span className="error">{props.children}</span>

